<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.fullname || activeUserInfo.username">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.fullname || activeUserInfo.username }}</p>
      <small>{{ activeUserInfo.role }}</small>
    </div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img key="onlineImg" :src="photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="toggleProfile">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>
          <vs-divider class="m-1" />
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>
<script>
import auth from "@/services/authService"

export default {
  data() {
    return {

    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.ActiveUser
    },
    photoURL() {
      return this.$store.state.ActiveUser.img || require("@/assets/images/portrait/small/default-avatar.png")
    }
  },
  methods: {
    logout() {
      auth.logout()
    },
    toggleProfile() {
      if (this.$route.path !== '/profile')
        this.$router.push('/profile')
    }
  },
  mounted() {
  }
}

</script>
<style scoped>
.vx-navbar-dropdown {
  width: 200px;
  max-width: 100%;
}

</style>
